import { render, staticRenderFns } from "./BundledProductsTransactionTable.vue?vue&type=template&id=27bbfa01&"
import script from "./BundledProductsTransactionTable.vue?vue&type=script&lang=js&"
export * from "./BundledProductsTransactionTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports